/*
 * @Author: 曹捷
 * @Date: 2021-01-08 10:51:15
 * @LastEditors: 曹捷
 * @LastEditTime: 2022-04-15 15:09:43
 * @Description: fileContent
 */
import { createApp } from 'vue'
import App from './App.vue'

// 默认主题
import 'obit-wui/styles/theme/industrial/index.less'
// import 'obit-wui/styles/theme/default/index.less'
import 'obit-wui/styles/index.less'
import './style/index.less'
import Antd from 'ant-design-vue';
import obitEnv from './components/obit-env/obit-env.vue'
import createRouter from './router/router.js'
import store from './store/store.js'
import API from './API'
import config from './config.js'
import cpsAmount from 'obit-wui/components/index.js'
import dictFmt from 'obit-wui/utils/dictFmt'
import cdnInit from 'obit-wui/utils/link'
import 'obit-wui/utils/input'
let app = createApp(App)
store.dispatch('settings/initConfig', config(app))
let router = createRouter()
let api = new API(router)
app.config.globalProperties.$http = api.methods;
app.config.globalProperties.$fmt = dictFmt(api.methods);
app.config.globalProperties.env = process.env.VUE_APP_ENV;
cdnInit()
// 权限校验，主要是路由权限
if (process.env.VUE_APP_MOCK === 'true') {
  require('./mock')
}
app.component('obitEnv', obitEnv)
app.use(router)
app.use(store)
app.use(Antd)
cpsAmount(app)
app.mount('#mainApp')
